import React from 'react';
import { ExternalLink } from 'lucide-react';

const PipelineCardCompact = ({ opportunity, stageColor, onClick }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value || 0);
  };

  return (
    <div
      onClick={() => onClick && onClick(opportunity)}
      className="bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition-shadow cursor-pointer"
      style={{ borderLeftColor: stageColor, borderLeftWidth: '3px' }}
    >
      <div className="flex items-start justify-between mb-2">
        <h4 className="text-sm font-semibold text-[#2B2D42] flex-1 pr-2">
          {opportunity.name}
        </h4>
        <ExternalLink className="h-3 w-3 text-[#6C757D] flex-shrink-0" />
      </div>
      
      <div className="flex items-center justify-between">
        <span className="text-lg font-bold" style={{ color: stageColor }}>
          {formatCurrency(opportunity.value)}
        </span>
        <span className="text-xs text-[#6C757D]">
          {opportunity.probability}%
        </span>
      </div>
    </div>
  );
};

export default PipelineCardCompact;
